import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiEye } from "react-icons/fi";
import { GoPrimitiveDot } from "react-icons/go";
import { useLazyQuery } from "@apollo/react-hooks";
import { APP_CONTEXT } from "../../../utils/context";
import PageHeader from "../../../components/PageHeader/PageHeader.component";
import Table, { TableIcons } from "../../../components/Table/Table.component";
import {
  SmallImageHolder,
  SmallImage,
  CompanyHolder,
  CompanyName,
} from "./Staff.style";

// GQL
import {
  GET_STAFF_PROFILES,
  GET_STAFF_PROFILES_EXPORT,
} from "../../../graphql/queries/staff.query";

const UserAdminAll = () => {
  const { setActiveSideNav, setPageTitle } = useContext(APP_CONTEXT);
  const [refetch, { data, loading, error }] = useLazyQuery(GET_STAFF_PROFILES, {
    variables: { order: "createdAt_DESC" },
    fetchPolicy: "no-cache",
  });
  const [getAppUsersExport, staffProfilesExport] = useLazyQuery(
    GET_STAFF_PROFILES_EXPORT
  );
  const [variables, setVariables] = useState({
    where: { AND: [{ NOT: { staff: null } }] },
  });

  useEffect(() => {
    setActiveSideNav("userManagement");
    setPageTitle("Manage Staff");
  });

  const getColor = (value) => {
    if (value) {
      return "#FF003A";
    }
    return "#39C568";
  };

  const HeaderInfo = [
    {
      Header: "Name",
      accessor: "firstName",
      search: true,
      id: "firstName",
      Cell: ({ row }) => {
        return (
          <CompanyHolder>
            <SmallImageHolder>
              <SmallImage src={row.original.staff.profileImageUrl} />
            </SmallImageHolder>
            <CompanyName>{row.original.firstName}</CompanyName>
          </CompanyHolder>
        );
      },
    },
    {
      Header: "Surname",
      accessor: "lastName",
      id: "lastName",
    },
    {
      Header: "Email",
      accessor: "email",
      id: "email",
    },
    {
      Header: "Status",
      accessor: "suspended",
      id: "suspended",
      Cell: ({ row }) => (
        <TableIcons>
          <GoPrimitiveDot
            style={{
              fontSize: "25px",
              color: getColor(row.original.suspended),
            }}
          />
          <span>{row.original.suspended ? "suspended" : "active"}</span>
        </TableIcons>
      ),
    },
    {
      Header: "Subscription",
      accessor: "subscriptionId",
      id: "subscriptionId",
      Cell: ({ row }) => {
        return (
          <TableIcons>
            <GoPrimitiveDot
              style={{
                fontSize: "25px",
                color: getColor(!row.original.staff.subscriptionId),
              }}
            />
            <span>
              {!row.original.staff.subscriptionId ? "None" : "Active"}
            </span>
          </TableIcons>
        );
      },
    },
    {
      Header: "Action",
      id: "actions",
      Cell: ({ row }) => (
        <TableIcons>
          <Link to={`/app/user-management/staff/${row.original.id}`}>
            <FiEye
              style={{ fontSize: "20px", color: "#07002F", cursor: "pointer" }}
            />
          </Link>
        </TableIcons>
      ),
    },
  ];

  const filters = [
    {
      header: "Date Created:",
      accessor: "createdAt",
      type: "daterange",
    },
    {
      header: "Status:",
      accessor: "status",
      placeholder: "Please select a Status",
      type: "select",
      options: [
        { value: "ACTIVE", text: "Active" },
        { value: "NEW", text: "New" },
      ],
    },
  ];

  return (
    <>
      <PageHeader title="Manage Staff" />
      <Table
        columns={HeaderInfo}
        data={(data && data.appUsers) || []}
        loading={loading}
        error={error}
        refetch={refetch}
        variables={variables}
        dataCount={(data && data.appUsersCount.length) || 0}
        pageCount={5}
        setVariables={setVariables}
        tableTitle="Manage Staff"
        tableOptions={["search", "download", "columns", "filter"]}
        filters={filters}
        downloadData={staffProfilesExport}
        getDownloadData={getAppUsersExport}
        downloadAccessor={
          staffProfilesExport.data ? staffProfilesExport.data.appUsers : []
        }
        fileName="StaffProfiles"
      />
    </>
  );
};

export default UserAdminAll;
